import { useEffect, useRef, useState } from 'react';
import { useAccount } from '../lib/account';
import { hueFor, initials } from '@archik/call';
import { navigate } from '../lib/router';

/** Top-bar corner: "Войти" for guests, an avatar with a menu for the signed in. */
export function AccountMenu() {
  const { me, loading, signInAvailable, signIn, signOut } = useAccount();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: PointerEvent) => {
      if (!root.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  if (loading) return null;
  if (!me) {
    return signInAvailable ? (
      <button className="btn ghost small sign-in" onClick={() => signIn()} title="Google, passkey или код на почту">
        Войти в аккаунт
      </button>
    ) : null;
  }

  const go = (path: string) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div className="account" ref={root}>
      <button
        className="account-avatar"
        style={{ '--hue': hueFor(me.id) } as React.CSSProperties}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="menu"
        title={me.email || me.name}
      >
        {initials(me.name)}
      </button>
      {open && (
        <div className="account-menu" role="menu">
          <div className="account-who">
            <strong>{me.name}</strong>
            {me.email && <span>{me.email}</span>}
          </div>
          <button role="menuitem" onClick={() => go('/me')}>Мои встречи</button>
          <button role="menuitem" onClick={() => go('/me/settings')}>Настройки</button>
          <button
            role="menuitem"
            onClick={() => {
              setOpen(false);
              void signOut();
            }}
          >
            Выйти
          </button>
        </div>
      )}
    </div>
  );
}
